import React, {Component} from 'react';
import {Form} from 'react-final-form';
import PropTypes from 'prop-types';
import {Panel, TextField, SaveButton} from '../../common';
import {MAX_PASSWORD_LEN, MIN_PASSWORD_LEN} from '../../../configs/constants';
import {
  nolessErrorMessage,
  nolongerErrorMessage, noSpacesErrorMessage,
  passwordDoesNotMatch, retypedPasswordDoesNotMatch,
} from '../../../configs/messages';

export default class ResetPassword extends Component {
  static propTypes = {
    match: PropTypes.shape({
      params: PropTypes.shape({
        token: PropTypes.string,
      }),
    }).isRequired,
    checkResetPassword: PropTypes.func.isRequired,
    resetPassword: PropTypes.func.isRequired,
  };

  componentWillMount() {
    const {checkResetPassword, match: {params: {token}}} = this.props;
    checkResetPassword({token});
  }

  onFormSubmit = (data) => {
    const {resetPassword, match: {params: {token}}} = this.props;
    const resetData = {
      token,
      password: data.password,
    };
    resetPassword(resetData);
  };

  validatePassword = (password = '', allValues = {}) => {
    const passwordTrimmed = password.trim();
    const savedPassword = allValues.confirmPassword;

    if (/\s/g.test(password)) {
      return noSpacesErrorMessage('Password');
    }
    if (passwordTrimmed.length < MIN_PASSWORD_LEN) {
      return nolessErrorMessage('Password', MIN_PASSWORD_LEN);
    }
    if (passwordTrimmed.length > MAX_PASSWORD_LEN) {
      return nolongerErrorMessage('Password', MAX_PASSWORD_LEN);
    }
    if (savedPassword && passwordTrimmed !== savedPassword) {
      return passwordDoesNotMatch;
    }

    return null;
  };

  validateConfirmPassword = (password = '', allValues = {}) => {
    const passwordTrimmed = password && password.trim();
    const savedPassword = allValues.password;

    if (/\s/g.test(password)) {
      return noSpacesErrorMessage('Password');
    }
    if (passwordTrimmed.length < MIN_PASSWORD_LEN) {
      return nolessErrorMessage('Password', MIN_PASSWORD_LEN);
    }
    if (passwordTrimmed.length > MAX_PASSWORD_LEN) {
      return nolongerErrorMessage('Password', MAX_PASSWORD_LEN);
    }
    if (savedPassword && passwordTrimmed !== savedPassword) {
      return retypedPasswordDoesNotMatch;
    }

    return null;
  };

  render() {
    return (
      <Panel
        title="Reset Password"
        size="m"
        headerSize="m"
      >
        <Form
          onSubmit={this.onFormSubmit}
          validateOnBlur={false}
          render={({handleSubmit, pristine, invalid}) => (
            <form
              action="#"
              className="form"
              onSubmit={handleSubmit}
            >
              <TextField
                label="New Password"
                name="password"
                inputType="password"
                validatorsArray={[this.validatePassword]}
                required
              />
              <TextField
                label="Retype Password"
                name="confirmPassword"
                inputType="password"
                validatorsArray={[this.validateConfirmPassword]}
                required
              />

              <div className="row row_center">
                <SaveButton size="xl" type="submit" text="Submit" disabled={pristine || invalid}/>
              </div>
            </form>
          )}
        />
      </Panel>
    );
  }
}
